const storeOutletProductFilters = {
  oFilterForm: null,
  aFilterGroups: null,
  aFilterInputs: null,
  aFilterCheckboxes: null,
  aFilterSelects: null,
  aFilterRadius: null,
  aFilterAddress: null,
  aFilterMobRadius: null,
  aFilterMobAddress: null,
  aFilterHiddenInputs: null,
  oFilterResults: null,
  aProducts: null,
  oPagingButtons: null,
  oShowAllResultsButton: null,
  aClearFilterButton: null,
  oClearAllFiltersButton: null,
  oSliders: null,
  oMobileFilterToggles: null,
  oMobileFilters: null,
  oMobileFiltersListItems: null,
  oMobileFiltersLevelBack: null,
  aCreatedSliders: [],
  oAjaxTrigger: null,
  bSkipSliderHandle: false,
  oCurrentFilters: {},
  iCurrentPageNr: 1,
  root: null,

  initialize: (useDeeplink, ajaxCallback, Vue = null) => {
    storeOutletProductFilters.oFilterForm = document.forms.filterForm;
    storeOutletProductFilters.aFilterGroups = document.querySelectorAll('.filter-title');
    storeOutletProductFilters.aFilterInputs = document.querySelectorAll('.js-filter-form .checkbox input');
    storeOutletProductFilters.aFilterCheckboxes = document.querySelectorAll('.js-filter-form input[type="checkbox"]');
    storeOutletProductFilters.aFilterSelects = document.querySelectorAll('.js-filter-form select');
    storeOutletProductFilters.aFilterRadius = document.getElementById('radius');
    storeOutletProductFilters.aFilterAddress = document.getElementById('address');
    storeOutletProductFilters.aFilterMobRadius = document.getElementById('mob-radius');
    storeOutletProductFilters.aFilterMobAddress = document.getElementById('mob-address');
    storeOutletProductFilters.aFilterHiddenInputs = document.querySelectorAll('.js-filter-form input[type="hidden"]');
    storeOutletProductFilters.oFilterResults = document.querySelector('.js-filter-results');
    storeOutletProductFilters.aClearFilterButton = document.querySelectorAll('.js-clear-filter');
    storeOutletProductFilters.oClearAllFiltersButton = document.querySelectorAll('.js-clear-all');
    storeOutletProductFilters.oMobileFilterToggles = document.querySelectorAll('.js-toggle-mobile-filters');
    storeOutletProductFilters.oMobileFilters = document.querySelector('.js-mobile-filters');
    storeOutletProductFilters.oMobileFiltersListItems = document.querySelectorAll('.js-filter-list-item');
    storeOutletProductFilters.oMobileFiltersLevelBack = document.querySelectorAll('.js-filters-mobile-back');
    storeOutletProductFilters.oSliders = document.querySelectorAll('.js-price-slider');
    storeOutletProductFilters.oPagingButtons = document.querySelectorAll('.js-pagination-movepage');
    storeOutletProductFilters.oShowAllResultsButton = document.querySelector('.js-pagination-showall');
    storeOutletProductFilters.aProducts = document.querySelectorAll('.product');

    storeOutletProductFilters.root = Vue;

    if (storeOutletProductFilters.oSliders.length) {
      storeOutletProductFilters.createSlider(ajaxCallback);
    }

    [].forEach.call(storeOutletProductFilters.aFilterInputs, (input) => {
      input.addEventListener('change', (e) => {
        storeOutletProductFilters.persistDisabledFilters(e);
      });
    });

    [].forEach.call(storeOutletProductFilters.aFilterCheckboxes, (checkbox) => {
        checkbox.addEventListener('change', (e) => {

            storeOutletProductFilters.changeRelatedCheckbox(checkbox);
            storeOutletProductFilters.filterProducts(e.target);

            if (checkbox.checked) {

                var filterwaarde = '';

                var filterwaarde1 = e.target.parentElement.getElementsByTagName('span')[0];
                    
                if (filterwaarde1)
                {
                    filterwaarde = filterwaarde1.getAttribute('data-filter-value');
                }

                if (!filterwaarde)
                {
                    filterwaarde = filterwaarde1.firstChild.nodeValue;
                }
                var filtertype = null;

                var top = e.target.closest(".accordion__item")

                if (top) {
                    filtertype = top.querySelector(".accordion__item__header").innerText;
                } else {
                    top = e.target.closest(".filters__mobile__level")
                    if (top) {
                        filtertype = top.querySelector(".filters__mobile__level__title").innerText;
                    }
                }

            }
        
          });
    });

    [].forEach.call(storeOutletProductFilters.oPagingButtons, (page) => {
      page.addEventListener('click', (e) => {
        e.preventDefault();
          storeOutletProductFilters.filterProducts(e.currentTarget);
      });
    });

    [].forEach.call(storeOutletProductFilters.aFilterSelects, (select) => {
      select.addEventListener('change', (e) => {
          storeOutletProductFilters.filterProducts(e.target);
      });
    });

    if (storeOutletProductFilters.aFilterRadius) {
        storeOutletProductFilters.aFilterRadius.addEventListener('change', (e) => {
            storeOutletProductFilters.filterProducts(e.target);
        });
    }

    if (storeOutletProductFilters.aFilterAddress) {
        storeOutletProductFilters.aFilterAddress.addEventListener('change', (e) => {
            storeOutletProductFilters.filterProducts(e.target);
        });
    }

    if (storeOutletProductFilters.aFilterMobRadius) {
        storeOutletProductFilters.aFilterMobRadius.addEventListener('change', (e) => {
            storeOutletProductFilters.filterProducts(e.target);
        });
    }

    if (storeOutletProductFilters.aFilterMobAddress) {
        storeOutletProductFilters.aFilterMobAddress.addEventListener('change', (e) => {
            storeOutletProductFilters.filterProducts(e.target);
        });
    }

    [].forEach.call(storeOutletProductFilters.aProducts, (product) => {
      product.addEventListener('click', () => {
        docCookies.setItem('storeOutletProductFiltersScrollTo', `${product.dataset.articlecode}`, '', '/');
      });
    });

    if (storeOutletProductFilters.oShowAllResultsButton !== null) {
      storeOutletProductFilters.oShowAllResultsButton.addEventListener('click', (e) => {
        e.preventDefault();
          storeOutletProductFilters.filterProducts(e.target);
        return false;
      });
    }

    [].forEach.call(storeOutletProductFilters.oClearAllFiltersButton, (button) => {
      button.addEventListener('click', storeOutletProductFilters.clearAllFilters);
    });

    [].forEach.call(storeOutletProductFilters.aClearFilterButton, (button) => {
      button.addEventListener('click', storeOutletProductFilters.clearFilter);
    });

    [].forEach.call(storeOutletProductFilters.oMobileFilterToggles, (toggle) => {
      toggle.addEventListener('click', storeOutletProductFilters.toggleMobileFilters);
    });

    [].forEach.call(storeOutletProductFilters.oMobileFiltersListItems, (item) => {
      item.addEventListener('click', (e) => {
        storeOutletProductFilters.openFilterLevel(item);
      }, false);
    });

    [].forEach.call(storeOutletProductFilters.oMobileFiltersLevelBack, (item) => {
      item.addEventListener('click', (e) => {
        storeOutletProductFilters.closeFilterLevel(e, item);
      });
    });

    // Get Filters from Url, Map them to OverviewFilters Object and preload filters
    if (useDeeplink && window.location.search !== '') {
      const oPreloadOverviewFilters = storeOutletProductFilters.getFiltersFromHash();
      storeOutletProductFilters.loadFiltersFromDeeplink(oPreloadOverviewFilters);
    } else {
      storeOutletProductFilters.removeHiddenClass();
      storeOutletProductFilters.scrollToProduct();
    }

    window.onpopstate = (e) => {
      let oPreloadOverviewFilters;
      oPreloadOverviewFilters = e.state != null ? oPreloadOverviewFilters = e.state : oPreloadOverviewFilters = storeOutletProductFilters.getFiltersFromHash();
      storeOutletProductFilters.loadFiltersFromDeeplink(oPreloadOverviewFilters);

      if (website.body.classList.contains('no-scroll')) {
        website.body.classList.remove('no-scroll');
      }
    };

    storeOutletProductFilters.removeLoadingClass();
  },
  getFiltersFromHash: () => {
    const oPreloadOverviewFilters = storeOutletProductFilters.newOverviewFilters();
    const aFilterTypes = (window.location.search.replace('?', '')).split('&');

    for (let iType = 0; iType < aFilterTypes.length; iType += 1) {
      const aKeyValues = aFilterTypes[iType].split('=');

      if (Array.isArray(oPreloadOverviewFilters[aKeyValues[0]])) {
        oPreloadOverviewFilters[aKeyValues[0]] = aKeyValues[1].split(';');
      } else {
        oPreloadOverviewFilters[aKeyValues[0]] = aKeyValues[1];
      }
    }

    return oPreloadOverviewFilters;
  },
  setInnerHTML: (elm, html) => {
    elm.innerHTML = html;

    Array.from(elm.querySelectorAll("script"))
        .forEach(oldScriptEl => {
            const newScriptEl = document.createElement("script");

            Array.from(oldScriptEl.attributes).forEach(attr => {
                newScriptEl.setAttribute(attr.name, attr.value)
            });

            const scriptText = document.createTextNode(oldScriptEl.innerHTML);
            newScriptEl.appendChild(scriptText);

            oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
        });
  },
    filterProducts: (trigger) => {
      // Set isLoading in App.js
      if (storeOutletProductFilters.root !== null) {
          storeOutletProductFilters.root.isLoading = true;
      }

      storeOutletProductFilters.oFilterForm.classList.add('is-loading');
      storeOutletProductFilters.oAjaxTrigger = trigger;

      let formContainer = storeOutletProductFilters.oFilterForm.querySelector('.js-accordion'); // Desktop filters
      const mobileFiltersUsed = (website.iScreenWidth < website.mobileBreakpoint);

      if (mobileFiltersUsed) {
          formContainer = storeOutletProductFilters.oMobileFilters;
      }

      var radius = "";
      var address = "";

      var radiusElement = document.getElementById("radius");
      var addressElement = document.getElementById("address");
      var mobRadiusElement = document.getElementById("mob-radius");
      var mobAddressElement = document.getElementById("mob-address");

      if (radiusElement && addressElement && mobRadiusElement && mobAddressElement) {
          if (!mobileFiltersUsed) {
              radius = radiusElement.value;
              address = addressElement.value;
              mobRadiusElement.value = radius;
              mobAddressElement.value = address;
          }
          else {
              radius = mobRadiusElement.value;
              address = mobAddressElement.value;
              radiusElement.value = radius;
              addressElement.value = address;
          }
      }

      if (storeOutletProductFilters.oAjaxTrigger) {
          if (storeOutletProductFilters.oAjaxTrigger.classList.contains('js-pagination-showall')) {
              storeOutletProductFilters.iCurrentPageNr = 0;
          } else if (storeOutletProductFilters.oAjaxTrigger.classList.contains('js-pagination-movepage') ||
              storeOutletProductFilters.oAjaxTrigger.parentElement.classList.contains('js-pagination-movepage')) {
              const iTriggerPageNr = storeOutletProductFilters.oAjaxTrigger.getAttribute('data-page') ||
                  storeOutletProductFilters.oAjaxTrigger.parentElement.getAttribute('data-page');

              if (iTriggerPageNr !== null) {
                  storeOutletProductFilters.iCurrentPageNr = parseInt(iTriggerPageNr, 10);
              }
          } else {
              storeOutletProductFilters.iCurrentPageNr = 1;
          }
      }

      storeOutletProductFilters.setOverviewFilters(storeOutletProductFilters.newOverviewFilters(),
          formContainer,
          storeOutletProductFilters.iCurrentPageNr);

      const postUrl =
          (`/StoreOutletProductFilter/OverviewAjax?contentId=${currContentId}&pageNr=${storeOutletProductFilters.iCurrentPageNr}&radius=${encodeURIComponent(radius)}&address=${encodeURIComponent(address)}`);
      
      fetch(postUrl,
              {
                  method: "POST",
                  headers: {
                      "Content-Type": "text/html; charset=UTF-8",
                      "Accept-Language": document.documentElement.lang,
                      "X-Requested-With": "XMLHttpRequest"
                  },
                  body: JSON.stringify(storeOutletProductFilters.oCurrentFilters),
                  credentials: 'same-origin',
              })
          .then(response => response.text())
          .then((response) => {

              storeOutletProductFilters.destroySliders();

              //storeOutletProductFilters.oFilterResults.innerHTML = response;
              storeOutletProductFilters.setInnerHTML(storeOutletProductFilters.oFilterResults, response);

              fAccordion();
              fInitCustomSelects();
              storeOutletProductFilters.initialize(false, true, storeOutletProductFilters.root);

              if (mobileFiltersUsed) {
                  if (storeOutletProductFilters.oAjaxTrigger) {
                      if (!(storeOutletProductFilters.oAjaxTrigger.classList.contains('js-pagination-showall') ||
                          storeOutletProductFilters.oAjaxTrigger.classList.contains('js-pagination-movepage') ||
                          storeOutletProductFilters.oAjaxTrigger.classList.contains('js-clear-all') ||
                          storeOutletProductFilters.oAjaxTrigger.id === 'productlist__sort')) {
                          storeOutletProductFilters.toggleMobileFilters();
                          const oMobileTrigger = document.getElementById(`${storeOutletProductFilters.oAjaxTrigger.id}`);
                          const oMobileTriggerParent = oMobileTrigger.closest('.js-filter-list-item');
                          storeOutletProductFilters.openFilterLevel(oMobileTriggerParent);
                      } else {
                          website.body.classList.remove('no-scroll');
                      }
                  }
              }

              setTimeout(() => {
                      storeOutletProductFilters.updateOverviewUrlHash(mobileFiltersUsed, storeOutletProductFilters.iCurrentPageNr);
                      storeOutletProductFilters.scrollToProduct();
                  },
                  0);

              if (storeOutletProductFilters.root !== null) {
                  storeOutletProductFilters.root.isLoading = false;
              }

              storeOutletProductFilters.removeLoadingClass();
              storeOutletProductFilters.removeHiddenClass();
              storeOutletProductFilters.enableFilterWithoutResults();
          });
      /*    
      if (storeOutletProductFilters.root !== null) {
          storeOutletProductFilters.root.isLoading = false;
      }

      storeOutletProductFilters.removeLoadingClass();
      storeOutletProductFilters.removeHiddenClass();
      storeOutletProductFilters.enableFilterWithoutResults();
      */
  },
  persistDisabledFilters: (event) => {
    const oChk = event.target;
    const oHidClones = storeOutletProductFilters.oFilterForm.querySelectorAll(`#hid${oChk.getAttribute('id')}, #hid${oChk.getAttribute('id')}`); // Find the matching hidden input field

    if (oHidClones) {
      if (oHidClones.length > 1) {
        [].forEach.call(oHidClones, (clone) => {
          clone.value = '';
          if (oChk.checked && oChk.disabled) {
            clone.value = oChk.value;
          }
        });
      } else {
        oHidClones[0].value = ''; // Reset the hidden field first (no value until proven guilty)

        // Only copy the value to the hidden field if its related checkbox is momentarily
        // both checked and disabled, as otherwise it won't be needed
        if (oChk.checked && oChk.disabled) {
          oHidClones[0].value = oChk.value;
        }
      }
    }
  },
  changeRelatedCheckbox: (checkbox) => {
    let relatedCheckbox;
    if (checkbox.id.indexOf('mob-') > -1) {
      const sStrippedCheckboxId = checkbox.id.replace('mob-', '');
      relatedCheckbox = storeOutletProductFilters.oFilterForm.querySelector(`#${sStrippedCheckboxId}`);
    } else {
      relatedCheckbox = storeOutletProductFilters.oFilterForm.querySelector(`#mob-${checkbox.id}`);
    }

    relatedCheckbox.checked = checkbox.checked;
  },
  updateOverviewUrlHash: (mobileFiltersUsed, pageNr) => {
    let formContainer = document.querySelector('.js-accordion');

    if (typeof mobileFiltersUsed === 'undefined') {
      mobileFiltersUsed = false;
    }

    if (mobileFiltersUsed) {
      formContainer = document.querySelector('.js-mobile-filters');
    }

    const oOverviewFilters = storeOutletProductFilters.newOverviewFilters();
    storeOutletProductFilters.setOverviewFilters(oOverviewFilters, formContainer, pageNr);

    const sHashUrl = `?${storeOutletProductFilters.getJsonFilterVals(oOverviewFilters)}`;
    if (window.location.search !== sHashUrl) {
      if (sHashUrl !== '?') {

        window.history.replaceState(undefined, undefined, sHashUrl);

        //window.history.pushState(oOverviewFilters, 'deeplink', sHashUrl);
      } else {
          window.history.replaceState(oOverviewFilters, 'initialState', window.location.pathname );
      }
    }

  },
  newOverviewFilters: () => {
      const oFilters = {
          page: 1,
          sort: '',
          radius: '',
          address: ''
      };

      var filters = document.getElementsByClassName('filters');
      if (filters) {
          var dataset = filters[0].dataset.filters;
          if (dataset) {
              dataset.split(';').forEach(tag => {
                  oFilters[tag] = [];
              });
          }
      }

      return oFilters;
  },
  setOverviewFilters: (oFilters, oForm, pageNr) => {
    const oFields = Array.prototype.slice.call(oForm.querySelectorAll('.js-filter-form input[type="checkbox"]:checked'));
    const oSelects = Array.prototype.slice.call(document.querySelectorAll('.js-filter-form select'));

    var radius = document.getElementById('radius');
    var address = document.getElementById('address');

    oFields.push(...oSelects);
    if (radius) {
      oFields.push(radius);
    }
    if (address) {
      oFields.push(address);
    }

    for (let i = 0; i < oFields.length; i += 1) {
      const oField = oFields[i];
      const sFilterType = oField.getAttribute('name');
      var sFilterVal = oField.value;
      if (oField.id === 'radius') {
        if (sFilterVal === "50") {
          sFilterVal = "";
        } else {
          oFilters[sFilterType] = sFilterVal;
        }
      } else if (oField.type === 'checkbox') {
        oFilters[sFilterType].push(sFilterVal);
      } else {
        oFilters[sFilterType] = sFilterVal;
      }
    }

      [].forEach.call(oForm.querySelectorAll('.js-price-slider-selected-max'),
          max => {
              var parent = max.parentElement;
              var min = parent.querySelector('.js-price-slider-selected-min');
              var minDefault = parent.querySelector('.js-price-slider-min');
              var maxDefault = parent.querySelector('.js-price-slider-max');

              if (max.value !== maxDefault.value || min.value !== minDefault.value) {
                  oFilters[min.getAttribute('name')] = min.value;
                  oFilters[max.getAttribute('name')] = max.value;

                  oFilters[minDefault.getAttribute('name')] = minDefault.value;
                  oFilters[maxDefault.getAttribute('name')] = maxDefault.value;

              } else {
                  delete oFilters[min.getAttribute('name')];
                  delete oFilters[max.getAttribute('name')];

                  delete oFilters[minDefault.getAttribute('name')];
                  delete oFilters[maxDefault.getAttribute('name')];

              }
          });


    oFilters.page = pageNr;
    storeOutletProductFilters.iCurrentPageNr = pageNr;

    storeOutletProductFilters.oCurrentFilters = oFilters;
  },
  getJsonFilterVals: (oAppliedFilters) => {
    let sHash = '';
    let sPrevArrFilter = '';
    const oAppliedFiltersKeys = Object.keys(oAppliedFilters);

    const defaultFilters = storeOutletProductFilters.newOverviewFilters();
      
    if (JSON.stringify(defaultFilters) !== JSON.stringify(oAppliedFilters)) {
      oAppliedFiltersKeys.forEach((filterType) => {
        if (Array.isArray(oAppliedFilters[filterType])) {
          oAppliedFilters[filterType] = oAppliedFilters[filterType].filter((v, i) => oAppliedFilters[filterType].indexOf(v) === i);

          if (oAppliedFilters[filterType].length > 0) {
            const aFilterVals = oAppliedFilters[filterType];

            if (sHash === '') {
              sHash = `${filterType}=${oAppliedFilters[filterType][0]}`;
            } else if ((sHash !== '') && (sPrevArrFilter !== filterType)) {
              sHash += `&${filterType}=${oAppliedFilters[filterType][0]}`;
            }

            for (let iFilter = 0; iFilter < aFilterVals.length; iFilter += 1) {
              if (iFilter > 0) {
                sHash += `;${aFilterVals[iFilter]}`;
              }
            }
            sPrevArrFilter = filterType;
          }
        } else {

          if (filterType === 'page' && oAppliedFilters[filterType] === 1) {
             return;
          }
          else if (filterType !== 'page' && oAppliedFilters[filterType].length === 0) {
             return;
          }
          else if (sHash !== '') {
             sHash += '&';
          }

          sHash += `${filterType}=${oAppliedFilters[filterType]}`;
        }
      });
    }

    return sHash;
  },
  loadFiltersFromDeeplink: (oPreloadOverviewFilters) => {
    const oPreloadOverviewFiltersKeys = oPreloadOverviewFilters !== null
      ? Object.keys(oPreloadOverviewFilters)
      : Object.keys(storeOutletProductFilters.newOverviewFilters());

    // Disable all filters
    [].forEach.call(storeOutletProductFilters.aFilterHiddenInputs, (input) => {
      const oInput = input;
      if (oInput.nextElementSibling !== null && oInput.nextElementSibling.type === 'checkbox') {
        oInput.value = '';
      }
    });

    [].forEach.call(storeOutletProductFilters.aFilterCheckboxes, (checkbox) => {
      const oCheckbox = checkbox;
      oCheckbox.checked = false;
    });

    if (oPreloadOverviewFilters !== null) {
      oPreloadOverviewFiltersKeys.forEach((filterType) => {
        if (oPreloadOverviewFilters !== null && Array.isArray(oPreloadOverviewFilters[filterType])) {
          if (oPreloadOverviewFilters[filterType].length > 0) {
            const aFilterValues = oPreloadOverviewFilters[filterType];
            for (let iFilter = 0; iFilter < aFilterValues.length; iFilter += 1) {
              storeOutletProductFilters.selectCheckbox(aFilterValues[iFilter]);
              storeOutletProductFilters.setHiddenInputValues(aFilterValues[iFilter], filterType);
            }
          }
        } else {
          const filterValue = oPreloadOverviewFilters[filterType];
          storeOutletProductFilters.setHiddenInputValues(filterValue, filterType);
        }
      });
    }

    if (oPreloadOverviewFilters !== null) {
      storeOutletProductFilters.iCurrentPageNr = parseInt(oPreloadOverviewFilters.page, 10);
    }

      storeOutletProductFilters.filterProducts(null);
  },
  clearFilter: (e) => {
    const sFilterValue = e.target.getAttribute('data-filter-value');
    const sFilterType = e.target.getAttribute('data-filter-type');

    if (sFilterValue === "filteraddress") {
        var radius = "";
        var address = "";

        var radiusElement = document.getElementById("radius");
        var addressElement = document.getElementById("address");
        var mobRadiusElement = document.getElementById("mob-radius");
        var mobAddressElement = document.getElementById("mob-address");

        if (radiusElement && addressElement && mobRadiusElement && mobAddressElement) {
            mobRadiusElement.value = radius;
            mobAddressElement.value = address;
            radiusElement.value = radius;
            addressElement.value = address;
        }
    }

    if (sFilterType === 'checkbox') {
        storeOutletProductFilters.selectCheckbox(sFilterValue, true);
    } else {
        storeOutletProductFilters.resetSliders(sFilterType);
    }

      storeOutletProductFilters.filterProducts(e.target);
    e.preventDefault();
  },
  clearAllFilters: (e) => {

    var radius = "";
    var address = "";

    var radiusElement = document.getElementById("radius");
    var addressElement = document.getElementById("address");
    var mobRadiusElement = document.getElementById("mob-radius");
    var mobAddressElement = document.getElementById("mob-address");

    if (radiusElement && addressElement && mobRadiusElement && mobAddressElement) {
        mobRadiusElement.value = radius;
        mobAddressElement.value = address;
        radiusElement.value = radius;
        addressElement.value = address;
    }

    [].forEach.call(storeOutletProductFilters.aFilterCheckboxes, (checkbox) => {
      const oCheckbox = checkbox;
      oCheckbox.checked = false;
    });

    storeOutletProductFilters.resetSliders();
      storeOutletProductFilters.filterProducts(e.target);
    e.preventDefault();
  },
  selectCheckbox: (value, clear = false) => {
    [].forEach.call(storeOutletProductFilters.aFilterCheckboxes, (checkbox) => {
      const oCheckbox = checkbox;
      if (oCheckbox.value === value) {
        oCheckbox.checked = !clear;
      }
    });
  },
  setHiddenInputValues: (value, type) => {
    [].forEach.call(storeOutletProductFilters.aFilterHiddenInputs, (input) => {
      const oInput = input;
      const sInputName = oInput.getAttribute('name');

      if (type.indexOf("min") === 0 && sInputName === type) {
        storeOutletProductFilters.setSliderValues(input, value, null);
      } else if (type.indexOf("max") === 0 && sInputName === type) {
        storeOutletProductFilters.setSliderValues(input, null, value);
      } else if (oInput.id === `hid${type + value}`) {
        oInput.value = value;
      }
    });

    [].forEach.call(storeOutletProductFilters.aFilterSelects, (select) => {
      if (select.getAttribute('name') === type) {
        select.value = value;
      }
    });
  },
  createSlider: (ajaxCallback) => {
      [].forEach.call(storeOutletProductFilters.oSliders, (slider) => {
        const oSlider = slider.querySelector('.range-slider__slider');

      const maxValue = parseFloat(slider.querySelector('.js-price-slider-max').value, 10);
      const minValue = parseFloat(slider.querySelector('.js-price-slider-min').value, 10);

      const selectedActualMinValue = slider.querySelector('.js-price-slider-selected-min');
      const selectedActualMaxValue = slider.querySelector('.js-price-slider-selected-max');
      const selectedSliderText = slider.querySelector('.js-selected-price-range');
      const selectedSliderTextMin = selectedSliderText.querySelector('.js-selected-price-range-min');
      const selectedSliderTextMax = selectedSliderText.querySelector('.js-selected-price-range-max');

      var hostLanguage = document.documentElement.lang;

      const step = 1;
      var margin = Math.ceil((maxValue - minValue) / (11 * step)) * step

      const oOptions = {
          start: [selectedActualMinValue.value, selectedActualMaxValue.value],
        range: {
            min: [minValue],
            max: [maxValue],
        },
        //behaviour: 'drag',
        connect: true,
        margin: margin,
        //step: step,
        cssPrefix: 'hbf-',
        format: {
          to: value => `${Math.round(value)}`,
          from: value => value,
        },
        tooltips: [
          {
              to: value => `${Math.round(value)}`,
              from: value => value,
          },
          {
            to: value => `${Math.round(value)}`,
            from: value => value,
          },
        ]
      };

      noUiSlider.create(oSlider, oOptions);

      oSlider.noUiSlider.on('update', (values, handle) => {
        if (!storeOutletProductFilters.bSkipSliderHandle) { // Prevents the AJAX call from being called for both handles each time one is moved
          const handleTooltips = oSlider.querySelectorAll('.hbf-handle .hbf-tooltip');

          selectedSliderTextMin.textContent = `${handleTooltips.item(0).innerHTML}`;
          selectedSliderTextMax.textContent = `${handleTooltips.item(1).innerHTML}`;
          selectedActualMinValue.value = values[0].replace('€', '');
          selectedActualMaxValue.value = values[1].replace('€', '');

          storeOutletProductFilters.bSkipSliderHandle = true;
        } else {
          storeOutletProductFilters.bSkipSliderHandle = false;
        }
      });

      oSlider.noUiSlider.on('end', (values, handle, unencoded, tap, positions) => {
        const min = Math.round(unencoded[0]).toString();
        const max = Math.round(unencoded[1]).toString();

        const maxV = parseInt(slider.querySelector('.js-price-slider-max').value, 10);
        const minV = parseInt(slider.querySelector('.js-price-slider-min').value, 10);

        if (minV !== min || maxV !== max) {
            storeOutletProductFilters.filterProducts(oSlider.parentElement);
        }
      });

      storeOutletProductFilters.aCreatedSliders.push(oSlider);
    });
  },
  resetSliders: (sFilterType) => {
      [].forEach.call(storeOutletProductFilters.aCreatedSliders, (slider) => {

          if (typeof sFilterType === 'undefined' || slider.noUiSlider.target.parentElement.id.includes(sFilterType)) {

              // Reset slider only if current values dont match the starting values
              const aStartingSliderValues = [];
              aStartingSliderValues.push(slider.noUiSlider.options.range.min[0], slider.noUiSlider.options.range.max[0]);

              const aCurrentSliderValuesStripped = [];
              const aCurrentSliderValues = slider.noUiSlider.get();
              [].forEach.call(aCurrentSliderValues, (value) => {
                      aCurrentSliderValuesStripped.push(parseFloat(value.replace('€', '')));
                  });

              if (JSON.stringify(aStartingSliderValues) !== JSON.stringify(aCurrentSliderValuesStripped)) {
                  slider.noUiSlider.set(aStartingSliderValues);
              }
          }
      });
  },
  destroySliders: () => {
    [].forEach.call(storeOutletProductFilters.oSliders, (slider) => {
      if (typeof slider.noUiSlider === 'object') {
        slider.noUiSlider.destroy();
      }
      storeOutletProductFilters.aCreatedSliders.splice(0, 1);
    });
    },
    setSliderValues: (input, min, max) => {
        [].forEach.call(storeOutletProductFilters.aCreatedSliders, (slider) => {
            if (slider.noUiSlider.target.parentElement === input.parentElement) {
              slider.noUiSlider.set([min, max]);
          }
      });
  },
  toggleMobileFilters: (event) => {
    if (storeOutletProductFilters.oMobileFilters.classList.contains('filters__mobile--active')) {
      storeOutletProductFilters.oMobileFilters.classList.remove('filters__mobile--active');
      website.body.classList.remove('no-scroll');
    } else {
      storeOutletProductFilters.oMobileFilters.classList.remove('d-none');
      storeOutletProductFilters.oMobileFilters.classList.add('d-flex');
      storeOutletProductFilters.oMobileFilters.classList.add('filters__mobile--active');

      if (!website.body.classList.contains('no-scroll')) {
        website.body.classList.add('no-scroll');
      }
    }

    if (event) {
      event.preventDefault();
    }
  },
  openFilterLevel: (item) => {
    const oCurrentFilterSubLevel = item.querySelector('.filters__mobile__level');
    oCurrentFilterSubLevel.classList.add('filters__mobile__level--active');
  },
  closeFilterLevel: (event, item) => {
    const oLevel = item.closest('.filters__mobile__level--active');
    if (oLevel) {
      oLevel.classList.remove('filters__mobile__level--active');
    }

    event.stopPropagation();
  },
  scrollToProduct: () => {
    if (docCookies.getItem('productFiltersScrollTo') !== null && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
      const oProductToScrollTo = document.querySelector(`[data-articlecode="${docCookies.getItem('productFiltersScrollTo')}"]`) ? document.querySelector(`[data-articlecode="${docCookies.getItem('productFiltersScrollTo')}"]`).parentElement : null;
      if (oProductToScrollTo) {
        imagesLoaded(storeOutletProductFilters.oFilterForm, () => {
          scrollIt(oProductToScrollTo, 0);
          docCookies.removeItem('productFiltersScrollTo', '/', '');
        });
      }
    } else {
      window.scrollTo(0, 0);
    }
  },
  removeHiddenClass: () => {
    if (storeOutletProductFilters.oFilterForm.classList.contains('is-hidden')) {
      storeOutletProductFilters.oFilterForm.classList.remove('is-hidden');
    }
  },
  removeLoadingClass: () => {
    if (storeOutletProductFilters.oFilterForm.classList.contains('is-loading')) {
      storeOutletProductFilters.oFilterForm.classList.remove('is-loading');
    }
  },
  enableFilterWithoutResults: () => {
    // Check for checkboxes that are checked and disabled
    storeOutletProductFilters.aFilterCheckboxes.forEach((checkbox) => {
      if ((checkbox.checked && checkbox.disabled) && checkbox.parentElement.querySelector('.filter__count').textContent === '0') {
        checkbox.disabled = false;
      }
    });
  },
};
